export const filesConstants = {
  UPLOADING: 'UPLOADING',
  DOWNLOADED: 'DOWNLOADED'
}



// WEBPACK FOOTER //
// ./src/constants/files.constants.js